export default __webpack_public_path__ + "static/N0020-85a88fddbccfe9be6a0525c456cbdba9.png";